"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.trackLog.goToSource': 'Vai alla fonte',
    'whatsapp.trackLog.status.neutral': 'Neutro',
    'whatsapp.trackLog.status.good': 'Buono',
    'whatsapp.trackLog.status.warning': 'Avviso',
    'whatsapp.trackLog.status.critical': 'Critico',
    'whatsapp.trackLog.type': 'Tipo:',
};
